import { NotificationService } from 'src/app/shared/services/notification.service';
import {
  inject,
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { TaskService } from 'src/app/kuba/task-manager/services/task.services';
import { ConfirmationService } from 'primeng/api';

import { BaseServices } from './../kuba.services';
import { HelperService } from 'src/app/_services/helper.service';
import { TimetableServices } from './services/timetable.service';
import { ValidationService } from 'src/app/kuba/shared/services/validation.service';
import { TypeOfWork } from './models/timetable';
import { Rights, FeatureKey } from './../../_models/feature';
import { DateSetting } from './../../_helpers/date-setting';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
@Component({
  selector: 'timetable-form',
  templateUrl: 'timetable-form.component.html',
  standalone: false
})
export class TimetableFormComponent
  extends DateSetting
  implements OnInit, OnChanges
{
  //#region variables
  private readonly notifications = inject(NotificationService);
  @Input() TimetableForm: FormGroup;
  @Input() readOnly: boolean = false;
  // "Repeat for additional days" (#4833) — only shown on the add form
  @Input() allowRepeat: boolean = false;
  readonly maxAdditionalDays = 7;
  additionalDaysLimitReached = false;

  workingModule: any;
  TypeofWorkPopup: FormGroup;
  isStatusDisable = true;
  projectDropDown: any[];
  parentKey: any;
  isEmployee: any;
  employeeId: any = this.route.snapshot.params['eid'];
  editTypes: any[];
  typeOfWorkId: number;
  featureId: any;
  StartDate: Date;
  EndDate: Date;
  StartTime: Date;
  EndTime: Date;
  BreakTime: Date;
  // min/max for p-calendar
  startMinDate: Date | undefined = undefined;
  startMaxDate: Date | undefined = undefined;
  endMinDate: Date | undefined = undefined;
  endMaxDate: Date | undefined = undefined;
  hasTouchedCalendar = false;
  addType = false;
  isHidden = false;
  employeeDropDown: SelectItem[];
  typeOfWorkDropDown: SelectItem[];
  approvalPersons: SelectItem[];
  parentId: any;
  hdnProject = false;
  hdnApprovalUser = false;
  viewType = false;
  workTypeId: number;
  existsAlerttext: string;
  isNameExists: boolean;
  isEmployeeName = true;
  isParentEmployee = false;
  // enabled end date for all the modules -- suggested by sathish
  hdnEndDate = true;
  myPageParent: string;
  isEmployeeParent: string;
  isReadOnly = false;
  isProject = false;
  isHideButton = true;
  loading = false;
  readonly = false;
  isSubContractorAndContacts = false;
  isNotSubContractorAndContacts = false;
  name: string;
  startTime: Date;
  endTime: Date;
  breakTime: Date;
  ApprovalUserId: any = [];
  TimeTableApproverId: any = [];
  isEmployeeTimetable: boolean = false;

  private subscriptions: Subscription[] = [];

  // #endregion

  //#region constructor

  /**
   * constructor
   * @param timetableService {TimetableServices}
   * @param _fb {FormBuilder}
   * @param route {ActivatedRoute}
   */
  constructor(
    private timetableService: TimetableServices,
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    private router: Router,
    private taskService: TaskService
  ) {
    super();
    this.parentId = route.snapshot.parent.parent.data['id'];
    this.parentKey = route.snapshot.parent.parent.data['parent'];
    this.isEmployee = <boolean>route.snapshot.data['employee'];
    this.myPageParent = route.snapshot.parent.parent.parent.data['parent'];
    if (+BaseServices.roleId === 4 || +BaseServices.roleId === 5) {
      this.isHideButton = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {}

  // #endregion

  //#region page-events

  /**
   * init page
   */
  ngOnInit() {
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule')).id;
    if (workingModule != null) {
      this.featureId = workingModule;
    }
    document.querySelector('body').classList.remove('opened');
    this.isEmployeeParent = this.route.snapshot.data['parent'];
    this.onTimetableWorkType();
    if (this.myPageParent) {
      this.isEmployeeName = false;
      this.isParentEmployee = true;
    }
    const currentUrl = this.router.url;
    if (currentUrl.includes('/employee/timetable')) {
      this.isEmployeeTimetable = true;
    } else {
      this.isEmployeeTimetable = false;
    }
    this.subscriptions.push(
      this.timetableService.getReadOnly$.subscribe(status => {
        this.isReadOnly = status;
      })
    );
    this.subscriptions.push(
      this.timetableService.getParent$.subscribe(parent => {
        this.isParentEmployee = parent ? parent : null;
      })
    );
    const snapshot = this.route.snapshot;

    // The employee timetable route is 'edit-timetable/:eid', where :eid is the employee id.
    // It has no 'edit' resolver, and no ancestor route declares an ':id' param — so without
    // the :eid lookup every branch below falls through to null and the AssingedUsers call
    // is made with the literal string "null", which fails int binding with a 422.
    this.parentId =
      snapshot.params?.['eid'] ??
      snapshot.parent?.parent?.params?.['id'] ??
      snapshot.data?.['edit']?.Featurekey ??
      BaseServices.FeatureKey;

    if (this.TimetableForm.value.Id > 0) {
      this.StartDate = this.getDateFromControl(this.TimetableForm.value.StartDate);
      this.EndDate = this.getDateFromControl(this.TimetableForm.value.EndDate);
      // set calendar min/max based on existing values
      if (this.StartDate) {
        this.endMinDate = new Date(this.StartDate);
      } else {
        this.endMinDate = undefined;
      }
      if (this.EndDate) {
        this.startMaxDate = new Date(this.EndDate);
      } else {
        this.startMaxDate = undefined;
      }
      this.StartTime = this.TimetableForm.value.StartDate
        ? new Date(
            `${this.getFormattedDateForTime(this.TimetableForm.value.StartDate)} ${this.TimetableForm.value.StartTime}`
          )
        : null;
      this.EndTime = this.TimetableForm.value.StartDate
        ? new Date(
            `${this.getFormattedDateForTime(this.TimetableForm.value.StartDate)} ${this.TimetableForm.value.EndTime}`
          )
        : null;

      // Ensure the form controls contain Date objects so p-calendar binds correctly
      const normalizedStart = this.StartDate ? new Date(this.StartDate) : null;
      const normalizedEnd = this.EndDate ? new Date(this.EndDate) : null;
      this.TimetableForm.get('StartDate')?.setValue(normalizedStart);
      this.TimetableForm.get('EndDate')?.setValue(normalizedEnd);
      this.TimetableForm.value.ApprovalUserId.forEach(x => {
        this.ApprovalUserId.push(x);
      });
      this.TimetableForm.value.TimeTableApproverId.forEach(x => {
        this.TimeTableApproverId.push(x);
      });

      this.TypeofWorkPopup = this._fb.group({
        typeofWork: [
          '',
          [Validators.required, ValidationService.noWhitespaceValidator]
        ]
      });
    } else {
      if (BaseServices.roleId === '5') {
        this.TimetableForm.patchValue({
          EmployeeId: BaseServices.UserFeatureKey
        });
        this.readonly = true;
      }
      this.StartDate = this.getDateFromControl(this.TimetableForm.value.StartDate);
      this.EndDate = this.getDateFromControl(this.TimetableForm.value.EndDate);
      // Ensure controls are normalized to Date for p-calendar
      this.TimetableForm.get('StartDate')?.setValue(this.StartDate ? new Date(this.StartDate) : null);
      this.TimetableForm.get('EndDate')?.setValue(this.EndDate ? new Date(this.EndDate) : null);
      if (this.StartDate) {
        this.endMinDate = new Date(this.StartDate);
      } else {
        this.endMinDate = undefined;
      }
      if (this.EndDate) {
        this.startMaxDate = new Date(this.EndDate);
      } else {
        this.startMaxDate = undefined;
      }
      this.StartTime = new Date(
        `1970-01-01 ${this.TimetableForm.value.StartTime}`
      );
      this.EndTime = new Date(`1970-01-01 ${this.TimetableForm.value.EndTime}`);
      this.TypeofWorkPopup = this._fb.group({
        typeofWork: [
          '',
          [Validators.required, ValidationService.noWhitespaceValidator]
        ]
      });
    }
    this.bindDropdowns();
    if (this.isEmployeeParent === 'EMPLOYEE') {
      this.isParentEmployee = true;
      this.isEmployeeName = false;
    }
    // enabled end date for all the modules -- suggested by sathish
    this.hiddenFieldHandler();

    // Project Name hide/show based on Project Module existence
    let leftNav = JSON.parse(sessionStorage.getItem('leftNav'));
    HelperService.filterTree(
      'Project',
      leftNav.filter(x => {
        if (x.name === 'Project') {
          if (x.children[3].checked === true) {
            this.isProject = true;
          }
        }
      }),
      'IsProject'
    );

    if (BaseServices.FeatureId === FeatureKey.SUB_CONTRACTOR) {
      this.isSubContractorAndContacts = true;
      this.name = BaseServices.Name;
    } else if (BaseServices.FeatureId === FeatureKey.CONTRACTOR_CONTACT) {
      this.isSubContractorAndContacts = true;
      this.name = BaseServices.Name;
    } else if (BaseServices.FeatureId === FeatureKey.CLIENT) {
      this.isSubContractorAndContacts = true;
      this.name = BaseServices.Name;
    } else if (BaseServices.FeatureId == FeatureKey.CLIENT_CONTACT) {
      this.isSubContractorAndContacts = true;
      this.name = BaseServices.Name;
    } else {
      this.isNotSubContractorAndContacts = true;
    }
    this.startTime = new Date('1970-01-01 8:00:00');
    this.endTime = new Date('1970-01-01 16:00:00');
    this.TimetableForm.get('BreakTime')?.setValue(new Date('1970-01-01T00:00:00'));
    this.workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
  }

  // #endregion

  //#region control-events

  /**
   * Editing TypeOfWork list
   * @param timetableType {any}
   */
  editType(timetableType: any) {
    this.typeOfWorkId = timetableType.Id;
    this.TypeofWorkPopup = this._fb.group({
      typeofWork: timetableType.Title
    });
  }
  /**
   * save Type of Work
   */
  saveType() {
    this.loading = true;
    let timetableType = new TypeOfWork();
    timetableType.Id = this.typeOfWorkId ? this.typeOfWorkId : 0;
    timetableType.Title = this.TypeofWorkPopup.value.typeofWork;
    timetableType.BusinessId = BaseServices.BusinessId;
    timetableType.Status = '1';
    if (timetableType.Id > 0) {
      this.subscriptions.push(
        this.timetableService
          .updateType(timetableType, this.parentKey)
          .subscribe((typeEdit: any) => {
            if (typeEdit) {
              this.bindTypeOfWorkDropdown();
              this.TimetableForm.get('TypeOfWorkId').patchValue(typeEdit.Id);
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.loading = false;
              this.typeOfWorkId = 0;
            } else {
              this.loading = false;
              this.existsAlerttext = this.translate.instant(`TOPIC_EXIST`);
              this.isNameExists = true;
              setTimeout(() => {
                this.isNameExists = false;
              }, 3000);
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.timetableService
          .createType(timetableType, this.parentKey)
          .subscribe((addedType: any) => {
            if (addedType) {
              this.loading = false;
              this.bindTypeOfWorkDropdown();
              this.TimetableForm.get('TypeOfWorkId').patchValue(addedType.Id);
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.addType = false;
            } else {
              this.loading = false;
              this.existsAlerttext = this.translate.instant(`TOPIC_EXIST`);
              this.isNameExists = true;
              setTimeout(() => {
                this.isNameExists = false;
              }, 3000);
            }
          })
      );
    }
  }
  /**
   * bind type of work after event trigger
   * @param typeofWork {any}
   */
  bindTypeofWork(typeofWork: any) {
    if (typeofWork) {
      this.bindTypeOfWorkDropdown();
      this.TimetableForm.get('TypeOfWorkId').patchValue(typeofWork.Id);
      this.notifications.success('UI_NOTIFICATIONS.SAVED');
      this.addType = false;
    } else {
      this.existsAlerttext = this.translate.instant(`TOPIC_EXIST`);
      this.isNameExists = true;
      setTimeout(() => {
        this.isNameExists = false;
      }, 3000);
    }
  }

  clear() {
    this.typeOfWorkId = 0;
    this.TypeofWorkPopup = this._fb.group({
      typeofWork: ['']
    });
  }
  /**
   * delete TypeOfWork based on Id
   * @param timetableType {number}
   */
  deleteType(timetableTypeId: number) {
    this.confirmationService.confirm({
      message: this.translate.instant('ARE_SURE_TO_PERFORM_ACTION'),
      accept: () => {
        let deleteTypeId = timetableTypeId;
        this.subscriptions.push(
          this.timetableService
            .deleteType(deleteTypeId)
            .subscribe(typeDelete => {
              if (typeDelete) {
                this.bindTypeOfWorkDropdown();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              }
            })
        );
      }
    });
  }
  /**
   * TimeTable Start Date Changed
   * @param date  {IMyDateModel}
   */
  onNewTimeTableStartDateChanged(event: any) {
    this.StartDate = this.getDateFromControl(event);

    if (this.StartDate) {
      const sd = new Date(this.StartDate);
      sd.setHours(0, 0, 0, 0);
      this.endMinDate = sd;
      // if end date exists and is before start, clear end date
      if (this.EndDate && this.EndDate < sd) {
        this.EndDate = null;
        this.TimetableForm.get('EndDate')?.setValue(null);
      }
    } else {
      this.endMinDate = undefined;
    }

    // Ensure time fields are normalized to Date objects if they exist as strings
    if (!this.StartTime && this.TimetableForm.value.StartTime) {
      this.StartTime = this.parseTimeToDate(this.TimetableForm.value.StartTime);
    }
    if (!this.EndTime && this.TimetableForm.value.EndTime) {
      this.EndTime = this.parseTimeToDate(this.TimetableForm.value.EndTime);
    }

    // If both dates and times are present, recalc hours
    if (this.StartDate && this.EndDate && this.StartTime && this.EndTime) {
      this.setCalculatedHours();
    }
  }
  /**
   * timeTable EndDate Changed
   * @param date {IMyDateModel}
   */
  onNewTimeTableEndDateChanged(event: any) {
    this.EndDate = this.getDateFromControl(event);

    if (this.EndDate) {
      const ed = new Date(this.EndDate);
      ed.setHours(0, 0, 0, 0);
      this.startMaxDate = ed;
      if (this.StartDate && this.StartDate > ed) {
        this.StartDate = null;
        this.TimetableForm.get('StartDate')?.setValue(null);
      }
    } else {
      this.startMaxDate = undefined;
    }

    // Ensure time fields are normalized to Date objects if they exist as strings
    if (!this.StartTime && this.TimetableForm.value.StartTime) {
      this.StartTime = this.parseTimeToDate(this.TimetableForm.value.StartTime);
    }
    if (!this.EndTime && this.TimetableForm.value.EndTime) {
      this.EndTime = this.parseTimeToDate(this.TimetableForm.value.EndTime);
    }

    if (this.StartDate && this.EndDate && this.StartTime && this.EndTime) {
      this.setCalculatedHours();
    }
  }

  /**
   * Normalize date control value from old p-calendar
   */
  private getDateFromControl(val: any): Date | null {
    if (!val) return null;
    // p-calendar will pass Date directly
    if (val instanceof Date) return val;
    if (val.jsdate) return new Date(val.jsdate.getTime());
    // sometimes the form may contain an object with 'formatted'
    if (val.formatted) {
      const parts = (val.formatted || '').split('/');
      if (parts.length === 3) {
        const day = Number(parts[0]);
        const month = Number(parts[1]) - 1;
        const year = Number(parts[2]);
        return new Date(year, month, day);
      }
    }
    // fallback: try Date constructor
    const parsed = new Date(val);
    return isNaN(parsed.valueOf()) ? null : parsed;
  }

  /**
   * Get date formatted as YYYY-MM-DD for time concatenation
   */
  private getFormattedDateForTime(val: any): string {
    const d = this.getDateFromControl(val);
    if (!d) return '';
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  /**
   * start Time Changed
   * @param date{any}
   */
  startTimeChanged(date: any) {
    this.StartTime = date;
    // ensure StartDate/EndDate are normalized
    if (!this.StartDate && this.TimetableForm.value.StartDate) {
      this.StartDate = this.getDateFromControl(this.TimetableForm.value.StartDate);
    }
    if (!this.EndDate && this.TimetableForm.value.EndDate) {
      this.EndDate = this.getDateFromControl(this.TimetableForm.value.EndDate);
    }
    if (this.StartDate && this.EndDate && this.StartTime && this.EndTime) {
      this.setCalculatedHours();
    }
  }
  /**
   * end Time Changed
   * @param date {any}
   */
  endTimeChanged(date: any) {
    let time: any;
    this.EndTime = date;
    if (
      this.TimetableForm.value.Id !== null &&
      this.TimetableForm.value.Id > 0
    ) {
      // Use normalization helper instead of direct jsdate access for compatibility
      this.EndDate = this.getDateFromControl(this.TimetableForm.value.EndDate);
      this.StartDate = this.getDateFromControl(this.TimetableForm.value.StartDate);
      this.StartTime = new Date(`1970-01-01 ${this.TimetableForm.value.StartTime}`);
    }
    // ensure StartDate/EndDate are normalized
    if (!this.StartDate && this.TimetableForm.value.StartDate) {
      this.StartDate = this.getDateFromControl(this.TimetableForm.value.StartDate);
    }
    if (!this.EndDate && this.TimetableForm.value.EndDate) {
      this.EndDate = this.getDateFromControl(this.TimetableForm.value.EndDate);
    }
    if (this.StartDate && this.EndDate && this.StartTime && this.EndTime) {
      this.setCalculatedHours();
    }
  }

  /**
   * Parse a time (string like '08:00' or Date) into a Date object (1970-01-01 T time)
   */
  private parseTimeToDate(timeVal: any): Date | null {
    if (!timeVal) return null;
    if (timeVal instanceof Date) return timeVal;
    try {
      // assume string like 'HH:MM'
      return new Date(`1970-01-01 ${timeVal}`);
    } catch {
      return null;
    }
  }
  /**
   * end Time Changed
   * @param date {any}
   */
  breakTimeChanged(breakTime: any) {
    this.BreakTime = breakTime;
    this.setCalculatedHours();
  }
  /**
   * Enforces the max additional-days limit live and flags when the cap is hit.
   * p-calendar (multiple) updates the control value before firing onSelect,
   * so the current selection is read back from the control.
   */
  onAdditionalDaysSelect() {
    const dates: Date[] =
      this.TimetableForm.get('AdditionalDays')?.value || [];
    if (dates.length > this.maxAdditionalDays) {
      this.TimetableForm.get('AdditionalDays')?.setValue(
        dates.slice(0, this.maxAdditionalDays)
      );
      this.additionalDaysLimitReached = true;
      return;
    }
    this.additionalDaysLimitReached = dates.length === this.maxAdditionalDays;
  }
  onCalendarFocus() {
    if (!this.hasTouchedCalendar) {
      this.hasTouchedCalendar = true;

      // On first focus, set to 00:30
      const defaultBreakTime = new Date('1970-01-01T00:30:00');
      this.TimetableForm.get('BreakTime')?.setValue(defaultBreakTime);
      this.breakTimeChanged(defaultBreakTime);
    }
  }
  /**
   * To clear type of work contrils
   */
  onBeforeTypeofWorkDialogHide() {
    this.TypeofWorkPopup.reset();
    this.viewType = false;
    this.typeOfWorkId = 0;
  }

  // #endregion

  //#region methods

  /**
   * This method fetches all information needed for the different dropdowns within the "new timetable dropdown"
   */
  bindDropdowns() {
  this.isHidden = true;

  // Initialize all dropdown arrays
  this.employeeDropDown = [];
  this.projectDropDown = [];
  this.typeOfWorkDropDown = [];
  this.editTypes = [];
  this.approvalPersons = [];

  // Get current language once
  const languageMode = this.translate.currentLang();
  const selectLabel = this.translate.instant('SELECT_DROPDOWN.SELECT') || 'Select';

  // Initialize dropdowns with default "Select"
  this.employeeDropDown.push({ label: selectLabel, value: null });
  this.projectDropDown.push({ label: selectLabel, value: null });
  this.typeOfWorkDropDown.push({ label: selectLabel, value: null });
  this.approvalPersons.push({ label: selectLabel, value: null });

  // ---Load Projects ---
  this.subscriptions.push(
    this.timetableService
      .getMyPageOrigin(BaseServices.BusinessId, languageMode, this.employeeId)
      .subscribe((result: any[]) => {
        if (Array.isArray(result)) {
          result.forEach((p: any) => {
            this.projectDropDown.push({
              label: p.label,
              value: p.value
            });
          });
        }
      })
  );

  // ---Load Employees ---
  // The 'new' routes carry no id at all, so parentId can legitimately be missing here.
  // Skipping the call leaves an empty dropdown instead of sending "null" into a route
  // parameter typed as int.
  const parentId = Number(this.parentId);
  if (Number.isInteger(parentId) && parentId > 0) {
    this.subscriptions.push(
      this.taskService
        .getAssignedUsers(
          BaseServices.BusinessId,
          this.featureId,
          parentId,
          BaseServices.ApplicationId
        )
        .subscribe((users: any[]) => {
          if (Array.isArray(users)) {
            // New array reference so PrimeNG 21's p-select re-renders its options.
            this.employeeDropDown = [
              ...this.employeeDropDown,
              ...users.map((u: any) => ({
                label: u.Name,
                value: u.EmployeeId
              }))
            ];
          }

          // ensure the selected employee is shown after async load
          const currentEmployeeId = this.TimetableForm?.get('EmployeeId')?.value;
          if (currentEmployeeId) {
            this.TimetableForm.patchValue({ EmployeeId: currentEmployeeId });
          }
        })
    );
  }

  // --Load Type of Work ---
  const typeOfWork = this.route.snapshot.data['typeOfWork'];
  if (Array.isArray(typeOfWork)) {
    typeOfWork.forEach((t: any) => {
      this.typeOfWorkDropDown.push({
        label: t.Title,
        value: t.Id
      });
      this.editTypes.push({
        Title: t.Title,
        Id: t.Id
      });
    });
  }

  // ---Load Approval Persons ---
  const approvalPersons = this.route.snapshot.data['approvalPerson'];
  if (Array.isArray(approvalPersons)) {
    approvalPersons.forEach((person: any) => {
      const rights = HelperService.validateJson(person.Rights);
      if (rights) {
        const hasAccess = HelperService.ApprovalPersonRightsCheck(
          rights,
          Rights.APPROVE_TIMETABLE
        );
        if (hasAccess) {
          this.approvalPersons.push({
            label: person.Name,
            value: person.Id
          });
        }
      }
    });
  }
}

  /**
   * bind TypeOfWork dropdown
   */
  bindTypeOfWorkDropdown() {
    this.subscriptions.push(
      this.timetableService
        .getTypeofworkbyBusinessId(BaseServices.BusinessId)
        .subscribe((workType: any) => {
          if (workType) {
            this.typeOfWorkDropDown = [];
            this.typeOfWorkDropDown.push({
              label: 'Select Type of Work',
              value: null
            });
            workType.forEach((typeOfWorkList: any) => {
              this.typeOfWorkDropDown.push({
                label: typeOfWorkList.Title,
                value: typeOfWorkList.Id
              });
            });
            this.editTypes = workType;
          }
        })
    );
  }
  
  /**
   * set Calculated Hours based on module
   */
  setCalculatedHours() {
    this.TimetableForm.get('HoursSpent').patchValue(null);
    let spentHours;

    // First calculate total hours as before
    if (
      this.parentKey === 'IC' ||
      this.parentKey === 'OS' ||
      this.parentKey === 'QS' ||
      this.parentKey === 'VEHICLE' ||
      this.parentKey === 'FDV'
    ) {
      if (this.StartDate && this.StartTime && this.EndTime && this.EndDate) {
        spentHours = HelperService.calculateHourSpent(
          this.StartDate,
          this.EndDate,
          this.StartTime,
          this.EndTime
        );
      }
    } else {
      if (this.StartDate && this.EndDate && this.StartTime && this.EndTime) {
        spentHours = HelperService.calculateHourSpent(
          this.StartDate,
          this.EndDate,
          this.StartTime,
          this.EndTime
        );
      }
    }

    // If we have hours calculated, apply break time deduction if exists
    if (spentHours) {
      if (this.BreakTime) {
        // Convert break time to minutes
        const breakMinutes =
          this.BreakTime.getHours() * 60 + this.BreakTime.getMinutes();

        // Convert total hours to minutes
        const [hours, minutes] = spentHours.split(':').map(Number);
        const totalMinutes = hours * 60 + minutes;

        // Subtract break time (ensure it doesn't go negative)
        const remainingMinutes = Math.max(0, totalMinutes - breakMinutes);

        // Convert back to HH:mm format
        const finalHours = Math.floor(remainingMinutes / 60);
        const finalMinutes = remainingMinutes % 60;
        spentHours = `${String(finalHours).padStart(2, '0')}:${String(finalMinutes).padStart(2, '0')}`;
      }

      this.TimetableForm.get('HoursSpent').patchValue(spentHours, { emitEvent: false });
    }
  }
  /**
   * to handler hidden Field
   */
  hiddenFieldHandler() {
    // as per disussion with tester enabled both start and end time for all modules
    switch (this.parentKey) {
      case 'IC':
      case 'FDV':
      case 'VEHICLE':
      case 'OS':
      case 'QS':
        this.hdnEndDate = true;
        this.hdnApprovalUser = true;
        break;
      case 'FS':
      case 'PROJECT':
      case 'EMPLOYEE':
      case 'KUBA_CONTROL':
        this.hdnEndDate = true;
        this.hdnApprovalUser = false;
        this.isEmployeeName = true;
        this.TimetableForm.get('EndDate').setValidators(Validators.required);
        break;
      case 'TIMETABLE':
        this.hdnEndDate = true;
        this.TimetableForm.get('EndDate').setValidators(Validators.required);
        this.TimetableForm.get('EndDate').updateValueAndValidity();
        this.hdnApprovalUser = true;
        break;
      default:
        break;
    }
  }

  /**
   * disable new work type based upon the rights
   */
  onTimetableWorkType() {
    let userRightsId = Rights.ADD_NEW_EMPLOYEE;
    let role = BaseServices.UserRole;
    if (role !== 'Editor') {
      this.isHideButton = false;
    }
    if (role === 'User') {
      this.isHideButton = this.hideTypeOfcase(this.parentKey);
    }
  }

  /**
   * get current date
   */
  getCurrentDate() {
    let dateFormat = new Date();
    return {
      year: dateFormat.getFullYear(),
      month: dateFormat.getMonth() + 1,
      day: dateFormat.getDate() - 1
    };
  }
  onApprovalNoticeChanged(e: any) {
    if (e.value) {
    }
  }
  // #endregion

  /**
   *
   * @param featureName
   */
  hideTypeOfcase(featureName: string): boolean {
    if (featureName === 'PROJECT') {
      return this.isUserRights(Rights.ADMINISTRATE_PROJECTS);
    } else if (featureName === 'FDV') {
      return this.isUserRights(Rights.ADMINISTRATE_FDV);
    } else if (featureName === 'IC') {
      return this.isUserRights(Rights.ADMINISTRATE_INTERNAL_CONTROL);
    } else if (featureName === 'OS') {
      return this.isUserRights(Rights.ADMINISTRATE_OTHER_SYSTEMS);
    } else if (featureName === 'QS') {
      return this.isUserRights(Rights.ADMINISTRATE_QUALITY_SYSTEM);
    } else if (featureName === 'VEHICLE') {
      return false;
    } else if (featureName === 'FS') {
      return false;
    } else if (featureName === 'KUNDE_EL') {
      return this.isUserRights(Rights.IK_KUNDE_EL_RIGHTS);
    } else if (featureName === 'FRAMEWORK') {
      return this.isUserRights(Rights.FRAMEWORK_AGREEMENT_RIGHTS);
    } else if (featureName === 'SA') {
      return this.isUserRights(Rights.SERVICE_AGREEMENT_RIGHTS);
    } else if (featureName == undefined) {
      return this.isUserRights(Rights.APPROVE_TIMETABLE);
    }
    return true;
  }

  isUserRights(rightsId: number): boolean {
    return BaseServices.checkUserRights(+rightsId, BaseServices.UserRole);
  }

  /**
   * Validates if a string is a valid JSON. Also has handling for invalid JSON-strings
   * @param input String validate for JSON
   * @returns JSON-object if string is valid JSON. Null if invalid JSON
   */
  validateJson(input: string): JSON | null {
    let result: JSON;
    try {
      result = JSON.parse(input);
      return result;
    } catch {
      return null;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
